import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {
    Box,
    Button,
    ButtonGroup,
    Card,
    CardContent,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Typography
} from "@mui/material";
import SendIcon from '@mui/icons-material/Send';
import LoadingButton from '@mui/lab/LoadingButton';


function LineupForm({ groupId, setGroupId }) {
    const [name, setName] = useState('');
    const [size, setSize] = useState(0);

    const [nameError, setNameError] = useState('');
    const [sizeError, setSizeError] = useState('');
    const [sizeWarning, setSizeWarning] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const [submitError, setSubmitError] = useState(false);


    //sets size warning and disables size error
    useEffect(() => {
        if(size > 3){
            setSizeWarning(true);
        } else {
            setSizeWarning(false);
        }

        if(size > 0 && size < 7){
            setSizeError('');
        }
    }, [size]);


    const validate = () => {
        let validated = true;
        if(name.trim() === ''){
            setNameError("Name Required.");
            validated = false;
        }
        if(size < 1 || size > 6){
            setSizeError("Must select amount of people in group.");
            validated = false
        }
        return validated;
    };

    const handleName = (newName) => {
        setName(newName);
        //removes name error if error is enabled
        if((newName.trim()).length !== 0 && nameError !== ''){
            setNameError("")
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setSubmitError(false);

        if(!validate()){
            return; //cancel submit if failed form validation
        }
        const groupData = {
            name: name,
            size: size
        }

        try {
            setIsLoading(true);
            const response = await axios.post('/api/groups', groupData);
            setGroupId(response.data.groupId);
            //set groupId in local storage
        } catch (error) {
            console.error("Error submitting line-up form: ", error);
            setSubmitError(true);
        } finally {
            setIsLoading(false);
        }


      //to fill
    };

    const toggleButtonStyle = { fontSize: "1.1rem"};

    return (
        <Card elevation={9} rounded="true" >
            <CardContent>
                <form>
                    <Typography sx={{fontSize: "1.1rem", fontWeight: 700, mb: 2}}>
                        What is your name?
                    </Typography>
                    <TextField
                        fullWidth
                        id="name-input"
                        type="text"
                        label="Name"
                        value={name}
                        onChange={(e) => handleName(e.target.value)}
                        inputProps={{maxLength: 35}}
                        error={nameError !== ""}
                        helperText={nameError}
                    />
                    <Typography sx={{fontSize: "1.1rem", fontWeight: 700, mt: 4, mb: 2}}>
                        How many people are in your group?
                    </Typography>
                    <ToggleButtonGroup
                        aria-label="group of numbered buttons"
                        value={size}
                        onChange={(e) => setSize(parseInt(e.target.value))}
                        exclusive
                        size="large"
                        fullWidth
                    >
                        <ToggleButton value={1} sx={{...toggleButtonStyle}}>1</ToggleButton>
                        <ToggleButton value={2} sx={{...toggleButtonStyle}}>2</ToggleButton>
                        <ToggleButton value={3} sx={{...toggleButtonStyle}}>3</ToggleButton>
                    </ToggleButtonGroup>
                    <ToggleButtonGroup
                        aria-label="group of numbered buttons"
                        value={size}
                        onChange={(e) => setSize(parseInt(e.target.value))}
                        exclusive
                        size="large"
                        fullWidth
                    >
                        <ToggleButton value={4} sx={{...toggleButtonStyle}}>4</ToggleButton>
                        <ToggleButton value={5} sx={{...toggleButtonStyle}}>5</ToggleButton>
                        <ToggleButton value={6} sx={{...toggleButtonStyle}}>6</ToggleButton>
                    </ToggleButtonGroup>
                    {
                        (sizeError !== '') &&
                        <Typography sx={{fontSize: "0.9rem", color:'#f44336', fontWeight: 500, mt: 1}}>
                            {sizeError}
                        </Typography>
                    }
                    {
                        sizeWarning &&
                        <Typography sx={{fontSize: "0.9rem", fontWeight: 500, mt: 1}}>
                            *Larger groups may increase wait times
                        </Typography>
                    }

                    <Box
                        display="flex"
                        justifyContent="center"
                        sx={{mt: 6}}
                    >
                        <LoadingButton
                            variant="contained"
                            endIcon={<SendIcon />}
                            onClick={handleSubmit}
                            size="large"
                            color="sfuRed"
                            sx={{fontSize: '1.1rem', fontWeight:'600'}}
                            loading={isLoading}>
                            Join Line-Up
                        </LoadingButton>
                    </Box>
                    {
                        submitError &&
                        <Typography sx={{fontSize: "0.9rem", fontWeight: 500, mt: 1}}>
                            Error joining line-up, please check internet and try again.
                            If error persists, please inform staff.
                        </Typography>
                    }
                </form>

            </CardContent>
        </Card>

    )
}

export default LineupForm;